import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import swal from 'sweetalert2';

class addEventBlock extends Component {
  constructor(props) {
    super(props);
    this.state={
      today: moment(),
      selectStartTime: moment(),
      selectEndTime: moment(),
      editId: 0,
      jobType: 0,
      jobTypeList: [
        {
          id: 1,
          title: '正常班',
        },{
          id: 2,
          title: '可支援',
        },{
          id: 6,
          title: '調整後正常班',
        },{
          id: 8,
          title: '例假',
        },{
          id: 9,
          title: '休假',
        },        {
          id: 10,
          title: '國定假日排假',
        },
      ]
    }
    this.handleSelectStartTimeChange = this.handleSelectStartTimeChange.bind(this);
    this.handleSelectEndTimeChange = this.handleSelectEndTimeChange.bind(this);
    this.handleJobTypeChange = this.handleJobTypeChange.bind(this);
    this.handleSaveWorkTime = this.handleSaveWorkTime.bind(this);
    this.handledeleteWorkTime = this.handledeleteWorkTime.bind(this);

  }

  componentWillReceiveProps(nextProps) {
    let jobType = this.state.jobTypeList.find((type) => type.id === Number(nextProps.event.resourceId));
    this.setState({
      editId: nextProps.event.id,
      jobType: jobType,
      selectStartTime: nextProps.event.start,
      selectEndTime: nextProps.event.end,
    })
  }

  handleSelectStartTimeChange(moment) {
    this.setState({
      selectStartTime: moment
    })
  }

  handleSelectEndTimeChange(moment) {
    this.setState({
      selectEndTime: moment
    })
  }

  handleJobTypeChange(e) {
    this.setState({
      jobType: e.target.value
    })
  }

  handleSaveWorkTime(e) {
    e.preventDefault();
    const { toggleOpen } = this.props;
    const { jobType, selectStartTime,  selectEndTime} = this.state;
    if (jobType === 0) {
      swal({
        type: 'error',
        text: '請選擇班別',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false,
        width: '250px'
      });
      return;
    } else if (selectEndTime.diff(selectStartTime) <= 0) {
      swal({
        type: 'error',
        text: '時間輸入有誤',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false,
        width: '250px'
      });
      return;
    }

    let data = {
      id: this.state.editId,
      start: selectStartTime.format('YYYY-MM-DD HH:mm'),
      end: selectEndTime.format('YYYY-MM-DD HH:mm'),
      actualStart: null,
      actualEnd: null,
      resourceId: jobType.id,
      title: ''
    }
    this.props.saveWorkTime(data);
    toggleOpen();
  }

  handledeleteWorkTime(e) {
    e.preventDefault();
    swal({
      type: 'warning',
      title: '確定刪除?',
      showCloseButton: true,
      heightAuto: false,
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#A9ABA8',
      confirmButtonText: '確定',
      cancelButtonText: '取消',
    }).then((result) => {
      if (result.value) {
        const { toggleOpen } = this.props;
        const { editId } = this.state;
        this.props.deleteWorkTime({
          id: editId.toString()
        });
        toggleOpen();
      }
    })
  }
  render() {
    let { isVisible, toggleOpen, event } = this.props;
    if (!isVisible) {
      return null;
    }



    return (
      <div className="u-editblock">
        <div className="form-block bounceIn">
          <div className="u-small-title">修改上班</div>
          <form className="u-form">
            <div className="row">
              <div className="col-6 col-pad-12">
                <label className="u-form__label text-align-right">日期： {event.start.format('YYYY-MM-DD')}</label>
              </div>
              <div className="col-6 col-pad-12">
                <label className="u-form__label text-align-right">班別：{this.state.jobType.title}</label>
              </div>
            </div>
            <div className="row">
              <div className="col-6 col-pad-12">
                <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>時段：</label>
                {
                  this.state.selectStartTime.diff(moment())>0?
                  <DatePicker
                  locale="zh-tw"
                  id="editShift_date_picker_selectStartTime"
                  showTimeSelect
                  showTimeSelectOnly
                  timeFormat="HH:mm"
                  dateFormat="LT"
                  timeCaption="Time"
                  selected={this.state.selectStartTime}
                  onChange={this.handleSelectStartTimeChange}
                  className="u-form__input mobile-hide"
                  disabledKeyboardNavigation
                />
                  :
                  <DatePicker
                  locale="zh-tw"
                  id="editShift_date_picker_selectStartTime"
                  showTimeSelect
                  showTimeSelectOnly
                  timeFormat="HH:mm"
                  dateFormat="LT"
                  timeCaption="Time"
                  selected={this.state.selectStartTime}
                  onChange={this.handleSelectStartTimeChange}
                  className="u-form__input mobile-hide"
                  disabledKeyboardNavigation
                  disabled
                />
                }

                <button
                    className="btn datepickinput desktop--hide"
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('editShift_date_picker_selectStartTime').click();
                    }}
                >
                  {this.state.selectStartTime.format('HH:mm')}
                </button>
              </div>
              <div className="col-6 col-pad-12">
                <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>至：</label>
                {
                  this.state.selectStartTime.diff(moment())>0?
                  <DatePicker
                  id="editShift_date_picker_selectEndTime"
                  locale="zh-tw"
                  showTimeSelect
                  showTimeSelectOnly
                  timeFormat="HH:mm"
                  dateFormat="LT"
                  timeCaption="Time"
                  selected={this.state.selectEndTime}
                  onChange={this.handleSelectEndTimeChange}
                  className="u-form__input mobile-hide"
                  disabledKeyboardNavigation
               

                />:
                <DatePicker
                id="editShift_date_picker_selectEndTime"
                locale="zh-tw"
                showTimeSelect
                showTimeSelectOnly
                timeFormat="HH:mm"
                dateFormat="LT"
                timeCaption="Time"
                selected={this.state.selectEndTime}
                onChange={this.handleSelectEndTimeChange}
                className="u-form__input mobile-hide"
                disabledKeyboardNavigation
                  disabled

              />
                }

                <button
                    className="btn datepickinput desktop--hide"
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('editShift_date_picker_selectEndTime').click();
                    }}
                >
                  {this.state.selectEndTime.format('HH:mm')}
                </button>
              </div> 
            </div>
            <div className="u-btn-group right">
              {
                this.state.selectStartTime.diff(moment())>0?
                  <>
                    <button className="btn btn-md save" onClick={this.handleSaveWorkTime}>儲存</button>
                    <button className="btn btn-md delete m-l-16" onClick={this.handledeleteWorkTime}>刪除</button>
                  </>
                :''
              }

              <button className="btn btn-md cancel m-l-16" onClick={
                (e) => {
                  e.preventDefault();
                  toggleOpen();
                }
              }>取消</button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default addEventBlock;